import React from "react"
import { Link } from "gatsby"
import { linksResolver } from "../../../../utils/linksResolver"
import styled from "styled-components"

export const FutureEvents = ({ futureEvents }) => {
  return (
    <FutureItems>
      <h4>Upcoming Meetings</h4>
      <Links>
        {futureEvents.map((item, i) => (
          <li key={i}>
            <Link href={linksResolver(item)}>{item.data.title.text}</Link>
          </li>
        ))}
      </Links>
    </FutureItems>
  )
}

const FutureItems = styled.div`
  @media (min-width: ${({ theme }) => theme.media.tablet_min}) {
    text-align: left;
    width: 48%;
  }
  @media (min-width: ${({ theme }) => theme.media.desktop_min}) {
    width: 32%;
  }
`

const Links = styled.ul`
  li {
    list-style-type: disc;
    margin-left: 20px;

    a {
      text-decoration: underline;

      &:hover {
        opacity: 0.8;
      }
    }
  }
`
